/**
 * Validates email for unsubscribe (same rule as BFF).
 * Requires: exactly one @, non-empty local and domain parts.
 */
export const validateUnsubscribeEmail = (email: string): boolean => {
  if (!email || typeof email !== 'string') return false;
  const trimmed = email.trim();
  const atIndex = trimmed.indexOf('@');
  if (atIndex === -1 || atIndex !== trimmed.lastIndexOf('@')) return false;
  const local = trimmed.slice(0, atIndex);
  const domain = trimmed.slice(atIndex + 1);
  return local.length > 0 && domain.length > 0;
};
